/*** IMPORTS FROM imports-loader ***/
var define = false;

import debounce from '../util/debounce';

const StickyHeader = {
  header: null,
  scrollStart: 0,
  stayHidden: false,
  init: function (stayHidden = false) {
    this.stayHidden = stayHidden;
    this.header = document.querySelector('.site-header');
    this.scrollStart = window.pageYOffset;
    this.setFixedHeader();
    this.updateOnScroll();
    document.addEventListener('scroll', debounce(this.updateOnScroll, 15));
  },
  updateOnScroll: function() {
    if (window.pageYOffset > StickyHeader.scrollStart + 200) {
      StickyHeader.header.classList.add('offscreen');
      StickyHeader.scrollStart = window.pageYOffset;
    } else if (window.pageYOffset - 20 < 0) {
      StickyHeader.header.classList.remove('offscreen');
      StickyHeader.scrollStart = window.pageYOffset;
    } else if (window.pageYOffset < StickyHeader.scrollStart - 200 && !StickyHeader.stayHidden) {
      StickyHeader.header.classList.remove('offscreen');
      StickyHeader.scrollStart = window.pageYOffset;
    }
    StickyHeader.setFixedHeader();
  },
  setFixedHeader: function() {
    const em = parseFloat(getComputedStyle(document.body).fontSize);
    if (window.pageYOffset > 20 * em) {
      if (!StickyHeader.header.classList.contains('fixed')) {
        StickyHeader.header.classList.add('transition');
      }
      StickyHeader.header.classList.add('fixed');
    } else {
      StickyHeader.header.classList.remove('fixed');
    }

    setTimeout(() => {
      StickyHeader.header.classList.remove('transition');
    }, 10);
  },
}

export default StickyHeader;

